import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { Col, Row, Form } from 'react-bootstrap';
import SignUpTitle from '../../Components/SignUpTitle/SignUpTitle';
import Buttons from '../../Components/Buttons/Buttons';
import PhoneNumber from '../../Components/PhoneNumber/PhoneNumber';
import Popup from '../../Components/Popup/Popup';
import PopEmail from '../../Images/PopEmail.png';
import CustomSelect from '../../Components/CustomSelect/CustomSelect';
import './UserSignUp.css';
import { useGlobalState } from '../../Contexts/GlobalStateContext';
import { useApi } from "../../Services/api";
import { emailRegex } from '../../Utils/regex';

const UserSignUp = () => {
  const [firstName, setFirstName] = useState('');
  const [firstNameError, setFirstNameError] = useState('');
  const [lastName, setLastName] = useState('');
  const [lastNameError, setLastNameError] = useState('');
  const [email, setEmailState] = useState('');
  const [emailError, setEmailError] = useState('');
  const [phoneNumber, setPhoneNumber] = useState('');
  const [phoneError, setPhoneError] = useState('');
  const [password, setPassword] = useState('');
  const [passwordError, setPasswordError] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [confirmPasswordError, setConfirmPasswordError] = useState('');
  const [submitted, setSubmitted] = useState(false);
  const [selectedOption, setSelectedOption] = useState({ value: '', label: '' });
  const [answer, setAnswer] = useState('');
  const [show, setShow] = useState(false);
  const [enterOTP, setEnterOTP] = useState('');
  const [enterOTPError, setEnterOTPError] = useState('');
  const [back, setBack] = useState(false);
  const [loaded, setLoaded] = useState(false);
  
  const navigate = useNavigate();
  const api = useApi();
  const location = useLocation();

  const { tempClientId, uniqueToken, setErrorVisible, setErrorMessage } = useGlobalState();
  
  useEffect(() => {
    if (!tempClientId && !uniqueToken) {
      navigate('/CompanySignUp');
    }
    setLoaded(true);
  }, []);
  
  useEffect(() => {
    // from first page to second
    if (tempClientId) {
      const getUserData = async () => {
        try {
          const userSignUpData = await api.get(`Client/GetClient?TempClientId=${tempClientId}&Email=&Token=`);
          const data = userSignUpData.data;
          if (!data.Success) {
            setErrorVisible(true);
            setErrorMessage(data.Error);
            return;
          }
          if (data.contactInformation.FirstName) {
            setFirstName(data.contactInformation.FirstName);
            setLastName(data.contactInformation.LastName? data.contactInformation.LastName : '');
            setEmailState(data.contactInformation.Email? data.contactInformation.Email : '');
            setPhoneNumber(data.contactInformation.PhoneNumber? data.contactInformation.PhoneNumber : '');
          }
        } catch (error) {
          console.error(error);
        } 
      }
      getUserData();
    }
    // only if back
    if (tempClientId && location.state && location.state.contactInformation) {
      setFirstName(location.state.contactInformation.FirstName);
      setLastName(location.state.contactInformation.LastName);
      setEmailState(location.state.contactInformation.Email);
      setPhoneNumber(location.state.contactInformation.PhoneNumber);
    }
  }, [tempClientId, location.state]);
  

  const handleSubmit = (event) => {
    event.preventDefault();
    setSubmitted(true);
    setFirstNameError(firstName ? '' : 'required field');
    setLastNameError(lastName ? '' : 'required field');
    setPasswordError(password ? '' : 'required field');

    let hasErrors = false;

    if (!email) {
      setEmailError('required field');
      hasErrors = true;
    } else if (!emailRegex.test(email)) {
      setEmailError('invalid!');
      hasErrors = true;
    } else {
      setEmailError('');
    }

    const phoneRegex = /^\+1\d{10}$/;
    if (!phoneNumber) {
      setPhoneError('required field');
      hasErrors = true;
    } else if (!phoneRegex.test(phoneNumber)) {
      setPhoneError('invalid!');
      hasErrors = true;
    } else {
      setPhoneError('');
    }

    if (!confirmPassword) {
      setConfirmPasswordError('required field');
      hasErrors = true;
    } else if (confirmPassword !== password) {
      setConfirmPasswordError('passwords do not match!');
      hasErrors = true;
    } else {
      setConfirmPasswordError('');
    }

    if (!hasErrors) {
      const UserSignUpData = async () => {
        try {
          let survey = '';
          if (selectedOption.value === 'Other') {
            survey = answer;
          } else {
            survey = selectedOption.value;
          }
          const body = {
            TempClientId: tempClientId,
            HowDidYouHearAboutVoyce: survey,
            contactInformation: {
              TempClientId: tempClientId,
              FirstName: firstName,
              LastName: lastName,
              Email: email,
              PhoneNumber: phoneNumber,
              Password: password,
              ConfirmPassword: confirmPassword,
            }
          };
          const userSignUpData = await api.post(`Client/Create/Step/${2}`, body);
          const data = userSignUpData.data;
          if (!data.Success) {
            setErrorVisible(true);
            setErrorMessage(data.Error);
            return
          } else {
            if (data.IsEmailVerified) { 
              navigate('/PaymentPage');
              return;
            }
            setShow(true);
          }
        } catch (error) {
          console.error(error);
        }
      };
      UserSignUpData();
    }
  };

  const handleBack = async() => {
      try{
        const backBody = {
          TempClientId: tempClientId,
        }
        const backApiData = await api.get(`Client/Back?TempClientId=${tempClientId}`,backBody);
        setBack(true);
        navigate('/CompanySignUp', {state:{...backApiData.data, isBack: true}});
      }catch(error){
        console.error(error);
      }
  };

  const handleNextPage = () => {
    if (!enterOTP) {
      setEnterOTPError('required field');
      return;
    }
    const verifyEmailData = async () => {
      try {
        const EmailBody = {
          TempClientId: tempClientId,
          Email:email,
          OTP:enterOTP,
          Token:uniqueToken,
        };
        const response = await api.post(`Client/VerifyEmail`, EmailBody);
        const VerifyEmailData = response.data;
        if (!VerifyEmailData.Success) {
          setEnterOTPError(VerifyEmailData.Error);
          return;
        }
        navigate('/PaymentPage');
      } catch (error) {
        console.log('error:', error);
      }
    };
    verifyEmailData();
    
  };

  const options = [
    { value: 'Customer Referral', label: 'Customer Referral' },
    { value: 'Google Search', label: 'Google Search' },
    { value: 'Social Media (Linked In, etc.)', label: 'Social Media (Linked In, etc.)' },
    { value: 'Sponsored Ad', label: 'Sponsored Ad' },
    { value: 'Trade show, conference, or event', label: 'Trade show, conference, or event' },
    { value: 'Voyce\'s partnership team', label: 'Voyce\'s partnership team' },
    { value: 'Other', label: 'Other' }
  ];

  const handleSelectChange = (option) => {
    setSelectedOption(option);
    if (option.value !== 'Other') {
      setAnswer(option.label);
    } else {
      setAnswer('');
    }
  };

  const handleClose = () => {
    setShow(false);
  };

  const handleResend = () => {
    const resendApi = async () => {
      try {
        const resendBody = {
          TempClientId: tempClientId,
        }
        const resendData = await api.post('Client/VerifyEmailResend', resendBody);
        
      } catch (error) {
        console.error('Error:', error);
      }
    };
    resendApi();
  }

  if (!loaded) return null;
  return (
    <>
      <SignUpTitle stepNumber={2} />
      <div className="form-container">
        <Form className="form-content" noValidate onSubmit={handleSubmit}>
          <Row className="step-row">
            <Form.Group as={Col} controlId="firstNameForm">
              <div className="form-group-inline">
                <Form.Label>First Name*</Form.Label>
                {submitted && !firstName && <div className="invalid-feedback" style={{ display: 'block' }}>required field</div>}
              </div>
              <Form.Control
                required
                type="text"
                placeholder="Enter your first name"
                value={firstName}
                onChange={(e) => {
                  setFirstName(e.target.value);
                  if (e.target.value) setFirstNameError('');
                }}
                className="step-inputBox"
              />
            </Form.Group>

            <Form.Group as={Col} controlId="lastNameForm">
              <div className="form-group-inline">
                <Form.Label>Last Name*</Form.Label>
                {submitted && !lastName && <div className="invalid-feedback" style={{ display: 'block' }}>required field</div>}
              </div>
              <Form.Control
                required
                type="text"
                placeholder="Enter your last name"
                value={lastName}
                onChange={(e) => {
                  setLastName(e.target.value);
                  if (e.target.value) setLastNameError('');
                }}
                className="step-inputBox"
              />
            </Form.Group>
          </Row>

          <Row className="step-row">
            <Form.Group as={Col} controlId="emailForm">
              <div className="form-group-inline">
                <Form.Label>Email*</Form.Label>
                {submitted && emailError && <div className="invalid-feedback" style={{ display: 'block' }}>{emailError}</div>}
              </div>
              <Form.Control
                required
                type="email"
                placeholder="Enter your email"
                value={email}
                onChange={(e) => {
                  setEmailState(e.target.value);
                  if (submitted) {
                    setEmailError('');
                  }
                }}
                className="step-inputBox"
              />
            </Form.Group>
            <Form.Group className="UserSignUp-phone" as={Col} controlId="phoneNumberForm">
              <PhoneNumber
                onPhoneNumberChange={setPhoneNumber}
                submitted={submitted}
                phoneError={phoneError}
                value={phoneNumber}
              />
            </Form.Group>
          </Row>

          <Row className="step-row">
            <Form.Group as={Col} controlId="passwordForm">
              <div className="form-group-inline">
                <Form.Label>Password*</Form.Label>
                {submitted && !password && <div className="invalid-feedback" style={{ display: 'block' }}>required field</div>}
              </div>
              <Form.Control
                required
                type="password"
                placeholder="Create your password"
                value={password}
                onChange={(e) => {
                  setPassword(e.target.value);
                  if (e.target.value) setPasswordError('');
                }}
                className="step-inputBox"
              />
            </Form.Group>
            <Form.Group as={Col} controlId="confirmPasswordForm">
              <div className="form-group-inline">
                <Form.Label>Confirm Password*</Form.Label>
                {submitted && confirmPasswordError && <div className="invalid-feedback" style={{ display: 'block' }}>{confirmPasswordError}</div>}
              </div>
              <Form.Control
                required
                type="password"
                placeholder="Confirm your password"
                value={confirmPassword}
                onChange={(e) => {
                  setConfirmPassword(e.target.value);
                  if (e.target.value) setConfirmPasswordError('');
                }}
                className="step-inputBox"
              />
            </Form.Group>
          </Row>
          
          <Row className="step-row">
            <Form.Group xs={6} as={Col} controlId="validationCustom05">
              <div className='form-group-inline'>
                <Form.Label>How Did You Hear About Voyce?</Form.Label>
              </div>
              <CustomSelect
                options={options}
                placeholder="Select an option"
                onSelect={(option) => {
                  const newOption = {value: option, label: option}
                  setSelectedOption(newOption);
                  if (newOption.value !== 'Other') {
                    setAnswer(newOption.label);
                  } else {
                    setAnswer('');
                  }
                }}
                value={selectedOption}
                defaultValue=""
              />
              {selectedOption.value === 'Other' && (
                <Form.Group controlId="answerForm">
                  <div className='form-group-inline'> 
                    <Form.Label>Please specify</Form.Label>
                  </div>
                  <Form.Control
                    type="text"
                    placeholder="Enter your answer"
                    value={answer}
                    className="step-inputBox"
                    onChange={(e) => setAnswer(e.target.value)}
                  />
                </Form.Group>
              )}

            </Form.Group>
          
          </Row>
          <div style={{marginTop: "30px", marginBottom: "100px"}}>
            <Buttons back handleBack={handleBack} handleSubmit={handleSubmit} />
          </div>
        </Form>
        

        {show && (
          <Popup
            show={show}
            handleClose={handleClose}
            title={
              <>
                <img src={PopEmail} className="UserSignUp-email-pop-image" alt="Verification" />
                <div className="UserSignUp-verify-text">Please verify your email</div>
              </>
            }
            titleStyle="popup-title"
            body={
              <>
                <div className="email-pop-body">
                  <div className="UserSignUp-body-text">
                    <p className="UserSignUp-email-text-first-line">Enter the One-time Password (OTP) sent to</p>
                    <p className="UserSignUp-email-text-first-line"><b>{email}</b>.</p> 
                  </div>
                  <div className="UserSignUp-pop-input">
                    <Form.Group as={Col} controlId="firstNameForm">
                      <div className="form-group-inline">
                        <Form.Label>OTP</Form.Label>
                        <div className='UserSignUp-Resend' onClick={handleResend} style={{ cursor: "pointer" }}>Resend</div>
                      </div>
                      <Form.Control
                        required
                        type="text"
                        value={enterOTP}
                        onChange={(e) => {
                          setEnterOTP(e.target.value);
                          if (e.target.value) setEnterOTPError('');
                        }}
                        style={{
                          boxShadow: enterOTPError ? '0 0 5px red' : 'none',
                          borderColor: enterOTPError ? 'red' : '',
                          height: "60px"
                        }}
                      />
                      {enterOTPError && <div className="UserSignUp-invalid-enterOTP">{enterOTPError}</div>}
                    </Form.Group>
                  </div>
                </div>
              </>
            }
            bodyStyle="popup-body"
            footer={
              <>
                <div className="UserSignUp-email-footer">
                  <div className="UserSignUp-btn-done" >
                    <Buttons className="UserSignUp-btn-done" handleSubmit={handleNextPage} text="Done" />
                  </div>
                  <div className="UserSignUp-footer-text-container">
                    <p>Didn’t receive an email? Confirm that the provided email address is correct, and try again.</p>
                  </div>
                </div>
              </>
            }
            footerStyle="UserSignUp-email-popup-footer"
          />
        )}
      </div>
    </>
  );
};

export default UserSignUp;
